import { AUTH_ENDPOINTS } from './authEndpoints';

export const DEFAULT_USERS_ADMIN_API_URL = 'https://app.mfkfejofesfelkfs.org/api/users-admin';
export const DEFAULT_PUBLIC_API_URL = 'https://app.mfkfejofesfelkfs.org/api';

export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_USERS_ADMIN_API_URL
    || process.env.REACT_APP_API_URL
    || DEFAULT_USERS_ADMIN_API_URL,
  publicBaseUrl: process.env.REACT_APP_PUBLIC_USERS_ADMIN_API_URL
    || process.env.REACT_APP_PUBLIC_API_URL
    || DEFAULT_PUBLIC_API_URL,
  refreshPath: AUTH_ENDPOINTS.session.refreshJwt,
  defaultTheme: process.env.REACT_APP_DEFAULT_THEME || 'light',
};
